import type {
  Body,
  Success,
  Failure,
  PathParams,
} from "@memento/app/endpoints/compilation/update";
import { createAuthenticatedMutationHook } from "src/hooks/createAuthenticatedMutationHook";
import { getUpdateCompilationEndpointUrl } from "src/libs/api-endpoint-lib";

type Trigger = (pathParams: PathParams, body: Body) => void;

export const useUpdateCompilation = createAuthenticatedMutationHook<
  Trigger,
  Success,
  Failure
>((startRequest) => ({ compilationId }, body) => {
  startRequest(getUpdateCompilationEndpointUrl(compilationId), {
    method: "POST",
    body,
  });
});
